// hamburger
$(function(){
  $('.hamburger').on('click', function() {
    // $('.header').toggleClass('open');
    $('#mask').toggleClass('open');
    $('body').toggleClass('scroll-lock');
  });
});

// mask
// document.querySelector('.hamburger').addEventListener('click', function () {
//   const mask = document.querySelector('.mask');
//   mask.style.maxHeight = `${window.innerHeight}px`;
// });

// FAQの展開処理
// $('.question_box').on('click', function() {
//   $(this).toggleClass('open');

//   // クリックされた `.question_box` の直後の `.answer_box` のみ対象
//   $(this).next('.answer_box')
//     .stop(true, true) // アニメーションをクリアしてスムーズに
//     .slideToggle();
// });


// jQuery(document).ready(function($) {
//   $('a[href*="#"]').on('click', function(event) {
//     // 同一ページ内のリンクのみ対象（パスとホストが一致）
//     if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') 
//         && location.hostname === this.hostname) {

//       const target = $(this.hash);
//       if (target.length) {
//         event.preventDefault();

//         $('.header').removeClass('open');
        
//         $('html, body').animate({
//           scrollTop: target.offset().top
//         }, 800);
//       }
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  const els = document.querySelectorAll("[data-inviewport]");

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-inviewport");
      } else {
        const rect = entry.target.getBoundingClientRect();
        const fullyOutAbove = rect.top + rect.height <= 0;
        const fullyOutBelow = rect.top >= window.innerHeight;
        if (fullyOutAbove || fullyOutBelow) {
          entry.target.classList.remove("is-inviewport");
        }
      }
    });
  }, {
    threshold: 0
  });

  els.forEach(el => io.observe(el));
});
